{
  "home-intro-headline": "#STARTUP STUDIO FROM POLAND",
  "farewell": "Goodbye"
}
